import { WEBCOIN_SECTIONS } from '@wwe-portal/web/utils/constants/webcoin';
import { useTranslations } from 'next-intl';
import { Each } from '@wwe-portal/ui/components/utils';
import { Mobile } from '@wwe-portal/ui/components/responsive';
import { EnergyPack } from '@wwe-portal/entities/webcoin.type';
import NotAvailableItems from '../not-available-items/not-available-items';
import { AlternativePurchaseTypes } from '@wwe-portal/web/services/payment/type';
import WebCoinShopCard from '../web-coin-shop-card/web-coin-shop-card';
import WebCoinShopCardResponsive from '../web-coin-shop-card/web-coin-shop-card-mobile';

interface EnergyListProps {
  ref: React.RefObject<HTMLDivElement | null>;
  energyPackageList: any;
  handleItemsPurchase: ({
    price,
    itemId,
    type,
    title,
    count,
  }: {
    price: number;
    itemId: number | string | undefined;
    type: any;
    title: string;
    count?: number;
  }) => void;
  purchasingOffer: any;
  isPaymentSuccess: boolean;
}

export const EnergyList = ({
  ref,
  energyPackageList,
  handleItemsPurchase,
  purchasingOffer,
  isPaymentSuccess,
}: EnergyListProps) => {
  const t = useTranslations();

  return (
    <Mobile
      fallback={
        <div id={WEBCOIN_SECTIONS.ENERGY_PACKS}>
          <div
            ref={ref}
            className="shop-featured mb-[10px] flex justify-between pt-[30px]"
          >
            <div className="mb-0 text-xl font-semibold">
              {t('trivia_limit')}
            </div>
          </div>
          {energyPackageList[0]?.buyed ? (
            <div data-id="trivia-energy-not-available" className="mb-40">
              <NotAvailableItems energy={true} />
            </div>
          ) : (
            <div className="flex flex-wrap justify-between">
              <Each
                data={energyPackageList}
                render={(item: EnergyPack, index) => {
                  const newItem = { ...item, image: '', rarity: '' };

                  switch (newItem.name) {
                    case 'xsEnergyPack':
                      newItem.image = '/assets/images/web-coin/energy1.png';
                      break;
                    case 'sEnergyPack':
                      newItem.image = '/assets/images/web-coin/energy2.png';
                      break;
                    case 'mEnergyPack':
                      newItem.image = '/assets/images/web-coin/energy3.png';
                      break;
                    default:
                      newItem.image = '/assets/images/web-coin/energy4.png';
                      newItem.rarity = 'energyExtra';
                      break;
                  }
                  return (
                    <div key={index} className="mb-[30px] max-w-[244px]">
                      <WebCoinShopCard
                        title={newItem.count + ' Energy'}
                        image={newItem.image}
                        name={newItem.name}
                        rarity={newItem.rarity}
                        quantity={newItem?.quantity}
                        price={Math.round(
                          newItem.value - (newItem.value * newItem.sale) / 100
                        )}
                        unlocked={newItem.unlocked}
                        handlePurchaseEnergyClick={(itemId, price, count) =>
                          handleItemsPurchase({
                            itemId,
                            price,
                            type: AlternativePurchaseTypes.Energy,
                            count,
                            title: newItem.name,
                          })
                        }
                        listType="energy"
                        paymentLoading={
                          purchasingOffer?.offerId === newItem.name
                        }
                        newItem={newItem}
                        index={index}
                      />
                    </div>
                  );
                }}
              />
            </div>
          )}
        </div>
      }
    >
      <div className="mb-[25px]" id={WEBCOIN_SECTIONS.ENERGY_PACKS}>
        <div
          ref={ref}
          className="shop-featured mb-[10px] flex justify-between pt-0"
        >
          <h4 className="mb-0 text-base font-semibold">{t('trivia_limit')}</h4>
        </div>
        {energyPackageList[0]?.buyed ? (
          <div data-id="trivia-energy-not-available" className="mb-40">
            <NotAvailableItems energy={true} />
          </div>
        ) : (
          <Each
            data={energyPackageList}
            render={(item: EnergyPack, index) => {
              const newItem = { ...item, image: '', rarity: '' };

              switch (newItem.name) {
                case 'xsEnergyPack':
                  newItem.image = '/assets/images/web-coin/energy1.png';
                  break;
                case 'sEnergyPack':
                  newItem.image = '/assets/images/web-coin/energy2.png';
                  break;
                case 'mEnergyPack':
                  newItem.image = '/assets/images/web-coin/energy3.png';
                  break;
                default:
                  newItem.image = '/assets/images/web-coin/energy4.png';
                  newItem.rarity = 'energyExtra';
                  break;
              }
              return (
                <div key={index} className="mb-10">
                  <WebCoinShopCardResponsive
                    title={newItem.count + ' Energy'}
                    image={newItem.image}
                    name={newItem.name}
                    quantity={newItem?.quantity}
                    rarity={newItem.rarity}
                    price={Math.round(
                      newItem.value - (newItem.value * newItem.sale) / 100
                    )}
                    unlocked={newItem.unlocked}
                    handlePurchaseEnergyClick={(itemId, price) =>
                      handleItemsPurchase({
                        itemId,
                        price,
                        type: AlternativePurchaseTypes.Energy,
                        title: newItem.name,
                      })
                    }
                    listType="energy"
                    paymentLoading={purchasingOffer?.offerId === newItem.name}
                    showModal={!isPaymentSuccess}
                    id={newItem.name}
                    data={newItem}
                  />
                </div>
              );
            }}
          />
        )}
      </div>
    </Mobile>
  );
};
